import React from "react";
import loadImage from "blueimp-load-image";
import classnames from "classnames";
import {getaddress} from "../../../api/UserApi";
import {
  TerritoryOptions,
  CurrencyOptions,
} from "../../../Constants/retailer";
import "./index.css";
import { post } from "jquery";

class AddCauseModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      postcode:"",
      address:{formatted_address:""},
      error_msg:"",
      img_content:"",
      isfixprice:true,
      isshopping:true,
      token: 0,
      territory:TerritoryOptions[0],
      finding_address:false
    };
  }
  componentDidMount(){
    const {territory = TerritoryOptions[0]} = this.props;
    this.setState({territory});
  }
  componentDidUpdate(prevProps){
    if(prevProps.territory!==this.props.territory){
      this.setState({territory:this.props.territory});
    }
  }
  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };
  handleSetFixPrice = (value) => () => {
    this.setState({
      isfixprice: value,
    });
  };
  handleSetShopping = (value) => () => {
    this.setState({
      isshopping: value,
    });
  };
  onChangePrice = ({ target: { value } }) => {
    const {territory} = this.state;
    let newValue = value.split(".");
    if (newValue.length > 1) {
      newValue =
        newValue.slice(0, -1).join("") + "." + newValue[newValue.length - 1];
    } else {
      newValue = value;
    }
    const countDecimals = function (number) {
      if (Math.floor(number) === Number(number)) return 0;
      return number.toString().split(".")[1].length || 0;
    };
    let number = Number(newValue.replace(/[^0-9\.]+/g, ""));
    const decimalPoints = countDecimals(newValue);
    if (decimalPoints >= 3) {
      number = number * 10;
    } else {
      number = number / Math.pow(10, 2 - decimalPoints);
    }
    this.setState({
      price: `${CurrencyOptions[territory]}${number.toFixed(2)}`,
    })
  };
  selectedFile = event=>{
    let _this = this;
    event.stopPropagation();
    event.preventDefault();
    const content = event.target.files[0];
    loadImage.parseMetaData(content, function (data) {
      //default image orientation
      var orientation = 0;
      if (data.exif) {
        orientation = data.exif.get("Orientation");
      }
      loadImage(
        content,
        function (canvas) {
          var base64data = canvas.toDataURL("image/png");
          var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
          _this.setState({ content: img_src });
          let img_content = "data:image/jpeg;base64," + img_src;
          _this.setState({ img_content });
        },
        {
          canvas: true,
          orientation: orientation,
        }
      );
    });
  }
  checkValidation = ()=>{
    const { title, token, img_content,isfixprice,territory,price,address } = this.state;
    const title_validation = title?true:false;
    const address_validation = address?true:false;
    const price_validation = isfixprice?price!==`${CurrencyOptions[territory]}0.00`&&price:true;
    const img_content_validation = img_content?true:false;
    const token_validation = token?true:false;
    const validation = title_validation&&address_validation&&price_validation&&img_content_validation&&token_validation;
    return validation;
  }
  findAddress = ()=>{
    const {postcode} = this.state;
    this.setState({finding_address:true});
    getaddress(postcode).then(res=>{
      if(res.status==="OK"){
        const address = res.results[0];
        this.setState({address,error_msg:""});
      }
      else{
        this.setState({error_msg:"There isn't matching address.",address:""});
      }
      this.setState({finding_address:false});
    }).catch(err=>{
      this.setState({error_msg:"Sorry we have some server problem. Try again later please."});
    })
  }
  createCause = ()=>{
    const { title, token,isfixprice,price,isshopping,postcode,address,content,territory } = this.state;
    const {createCause} = this.props;
    const payload={
      title,
      address:{...address,postcode},
      img_content:content,
      is_price_fixed:isfixprice,
      is_token_shopping:isshopping,
      // price:price?parseFloat(Number(price.substring(1)).toFixed(2)):0,
      price:price||`${CurrencyOptions[territory]}0.00`,
      token:Number(token)
    }
    createCause(payload);
  }
  render() {
    const { title, token, img_content,isfixprice,territory,price,isshopping,postcode,finding_address,address,error_msg,imgtitle } = this.state;
    return (
      <div
        className="modal fade add-cause-dialog"
        id="add_cause_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content add-cause-content">
            <div className="modal-header">
              <h5 className="modal-title">Add a cause</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1 add-cause-dialog-body">
             
              <p className="add-cause-title">
                Cause title
              </p>
              <input
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("title")}
                value={title}
              />
              <p className="add-cause-title">
                Address
              </p>
              <div className="row-div">
                <input 
                  className="form-control" 
                  type="text" 
                  placeholder={`${territory==="USA"?"Zip Code":"Post Code"}`} 
                  value={postcode}
                  onChange={this.handleInputChange("postcode")}
                  />
                <button className="btn btn-green" onClick={this.findAddress}>Find Address</button>
              </div>
              {finding_address&&<i className="fa fa-2x fa-sync fa-spin text-muted" />}
              {!finding_address&&<p>{error_msg?error_msg:address.formatted_address}</p>}
              <p className="add-cause-title">
                Image
              </p>
              <button 
                className="btn btn-green"
                onClick={()=>{this.upload.click()}}
              >
                  Select Image
              </button>
              <input
                  type="file"
                  id="image"
                  name="image"
                  accept="image/*"
                  ref={(ref) => this.upload = ref}
                  style={{display: 'none'}}
                  onChange={this.selectedFile}
              />
              {img_content&&<div className="image-div" style={{backgroundImage:`url(${img_content})`}}>
                </div>}
              <p className="add-cause-title">Price</p>
              <div className="option-container">
                <p className="option-title">
                    <React.Fragment>
                      <b>Fixed</b> or{" "}
                    </React.Fragment>
                  <b>Manual</b>
                </p>
                <div className="option-container">
                  <div
                    className={classnames("check-box",{
                      checked: isfixprice,
                    })}
                    onClick={this.handleSetFixPrice(true)}
                  ></div>
                  <div
                    className={classnames("check-box",{
                      checked: !isfixprice,
                    })}
                    onClick={this.handleSetFixPrice(false)}
                    style={{
                      marginLeft: "80px",
                    }}
                  ></div>
                </div>
              </div>
              {isfixprice&&<input
                type="text"
                placeholder={`${CurrencyOptions[territory]}00.00`}
                className="form-control form-control-md form-control-alt"
                onChange={this.onChangePrice}
                value={price}
              />}
              <p className="add-cause-title">Token reward</p>
              <div className="option-container">
                <p className="option-title">
                    <React.Fragment>
                      <b>Shopping</b> or{" "}
                    </React.Fragment>
                  <b>Premier</b>
                </p>
                <div className="option-container">
                  <div
                    className={classnames("check-box",{
                      checked: isshopping,
                    })}
                    onClick={this.handleSetShopping(true)}
                  ></div>
                  <div
                    className={classnames("check-box",{
                      checked: !isshopping,
                    })}
                    onClick={this.handleSetShopping(false)}
                    style={{
                      marginLeft: "80px",
                    }}
                  ></div>
                </div>
              </div>
              <input
                type="number"
                placeholder="0"
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("token")}
                value={token}
              />
              <div className="add-cause-footer">
                  <button className="btn btn-green"
                    onClick={this.createCause}
                    disabled={!this.checkValidation()}
                    data-dismiss="modal">
                      Create
                   </button>
                   <button className="btn btn-orange"
                    data-dismiss="modal">
                      Add later
                   </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddCauseModal;



// WEBPACK FOOTER //
// ./src/screens/Cause/AddCauseModal/index.js